import { FormControlLabel, Switch, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import BudgetControlTable from "./BudgetControlTable";
import { useDispatch, useSelector } from "react-redux";
import { setIsBudgetOverused } from "../../../../../features/bizDevelopmentDashboardSlice";

const BudgetControlTableView = () => {
  const dispatch = useDispatch();
  const budgetOveruse = useSelector(
    (state: any) => state.bizDevelopmentDashboard.isBudgetOverused,
  );

  //Budget MetaData
  const budgetMetaDataOfBizDevelopment = useSelector(
    (state: any) =>
      state.bizDevelopmentDashboard.budgetMetaDataOfBizDevelopment,
  );

  const formatTitle = (title: string): string => {
    // Rename cpa_constraint and perc_of_qftd_rr_budget_use to display title
    if (title.toLowerCase() === "cpa constraint") return "CPA Budget";
    if (title.toLowerCase() === "perc of qftd rr budget use")
      return "% of RR Budget Used";
    return title.replace(/^Perc Of\s*/i, "% ");
  };

  // Derive tableHeadings from metadata, sorted by order
  const tableHeadings: { [key: string]: string } = Object.fromEntries(
    Object.entries(budgetMetaDataOfBizDevelopment ?? {})
      .filter(([key]) => key !== "total_income_constraint") // exclude
      .sort(([, a]: any, [, b]: any) => Number(a.order) - Number(b.order))
      .map(([key, meta]: any) => [key, formatTitle(meta.title)]),
  );

  return (
    <>
      <Box
        px={2}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
        pb={2}
      >
        <Typography variant="body2" fontSize={"12px"}>
          Click on a Bar to see the full Details, Or switch to Graph View
        </Typography>

        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          <Typography>Budget Overuse</Typography>

          <FormControlLabel
            control={
              <Switch
                data-tracker="821"
                color="secondary"
                size="medium"
                checked={budgetOveruse}
                onChange={(e) =>
                  dispatch(setIsBudgetOverused(e.target.checked))
                }
              />
            }
            label=""
          />
        </Stack>
      </Box>
      <BudgetControlTable
        tableHeadings={tableHeadings}
        budgetOveruse={budgetOveruse}
      />
    </>
  );
};

export default BudgetControlTableView;
